<template>
    <vs-popup fullscreen :active.sync="isSidebarActiveLocal" title="Detayları" v-esc="escape">
      <div class="con-example-prompt content-wrapper" id="temelWrap" v-if="detailData != null">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12" id="" vs-justify="space-between">
          <vs-col vs-type="flex" vs-w="12" class="pl-5 py-5">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="space-between">
                <span class="text-primary bold h4">
                  {{detailData.userWantDto.branchName}} ({{detailData.userWantDto.userName}}) ({{formatDate(detailData.userWantDto.created)}})
                </span>
                <vs-button color="primary" @click="showStatusLogs">
                  İşlem Geçmişi Görüntüle
                </vs-button>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="mt-1">
                <span class="h5 w-full">
                  {{detailData.userWantDto.content}}
                </span>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
        </vs-row>
        <vs-divider color="primary" class="px-5 m-0 my-1" />
        <vs-row id="billContentEntry" vs-type="flex" vs-w="12" vs-justify="space-between"
              v-for="(entry,index) in detailData.entries" :key="index">
              <vs-row :vs-justify="entry.userId != $currentUser.id ?  'flex-start' : 'flex-end'">
  <vs-col type="flex" vs-justify="flex-end" vs-align="center" vs-w="6" style="margin-right: 1rem;">
    <vs-card class="content-card">
      <div slot="header">
        <span>
          {{'('+entry.userName+')'}}
        </span>
      </div>
      <div class="content-wrapper">
        <span>{{ entry.content }}</span>
      </div>
       <div slot="footer">
        <vs-row vs-justify="flex-end">
          <span style="font-size: 0.7rem;">{{(entry.createdText)}}</span>
        </vs-row>
      </div> 
    </vs-card>
  </vs-col>
</vs-row> 
            </vs-row>
      </div>
      <div class="fixed-input">
        <form data-vv-scope="form-1" @submit.prevent>
          <vs-row vs-type="flex" vs-w="12" id="billFooter" class="px-6" vs-justify="center">
          <vs-col vs-type="flex" vs-w="11" class="pl-5 ">
            <div class="w-full">
            <vs-textarea 
              label="Yorum" 
              name="Yorum" 
              v-validate="'required|min:2'" 
              size="large" 
              v-model="comment"
              @keydown.enter.exact.prevent="createComment"
              @keydown.shift.enter.prevent="newLine"
            />
      </div>
          </vs-col>
          
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" id="billFooter" class="px-6" vs-justify="center">
          <vs-col vs-type="flex" vs-w="11" class="pl-5">
            <vs-button :disabled="!isCommentValid" size="small" type="gradient" @click="createComment" >Gönder
            </vs-button>
          </vs-col>
        </vs-row>
        </form>
      </div>
      <vs-popup :active.sync="statusLogsPopupActive" title="Statü Logları">
      <vs-list>
        <vs-list-item v-for="(log, index) in statusLogs" :key="index" class="status-log-item">
          <div>
            <vs-row>
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
                <span class="log-text">{{ log.text }}</span>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
                <span class="log-user">{{ log.userName }}</span>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
                <span class="log-date">{{ log.date }}</span>
              </vs-col>
            </vs-row>
          </div>
        </vs-list-item>
      </vs-list>
    </vs-popup>
    </vs-popup>

    <!-- Statü Logları Popup -->
    
</template>


<script>
import { getDetail, addComment, getLogs } from "@/api/UserWant";
import companyInfo from '../../../model/constants/companyInfo';
export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {}
      }
    },
    data(){
      return{
        logo:companyInfo.logo,
        detailData:{},
        comment:'',
        moment: require('moment-timezone'),
        statusLogs: [],
        statusLogsPopupActive: false
      }
    } ,
    computed: {
      isCommentValid() {
      return this.comment !== null && this.comment.trim() !== ''
    },
        isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeSidebar");
            this.$validator.reset();
            this.initValues();
          }
        }
      }
    },
    watch: {
      isSidebarActive: function (val) {
        if (!val) return;
        console.log(this.data);
        getDetail(this.data.id).then((res)=>{
            if (res && res.status == 200) {
                console.log(res.data);
                this.detailData = res.data;
                setTimeout(() => {
                      const element = document.getElementById("temelWrap");
                      element.scrollTop = element.scrollHeight;
                    }, 200); // 200 milisaniye (0.2 saniye) bekle
                this.comment=''
            }else{
                this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hata : " + res.status,
              });
            }
        })
      }
    },
    methods:{
      formatDate(dateString) {
      return this.moment(dateString).format('DD/MM/YYYY HH:mm')
    },
        escape() {
        this.isSidebarActiveLocal = false;
    },
    newLine(e) {
      this.comment += '\n';
    },
    createComment: async function () {
      let newComment = {
        userWantId : this.data.id,
        content : this.comment
      }
      let checker;
      checker = await this.$validator.validateAll("form-1");
      if (checker) {
        addComment(newComment).then(res => {
                if (res && res.status == 200) {
                    this.detailData.entries.push(res.data);
                    setTimeout(() => {
                      const element = document.getElementById("temelWrap");
                      element.scrollTop = element.scrollHeight;
                    }, 200); // 200 milisaniye (0.2 saniye) bekle
                    this.comment = '';
                    this.$vs.notify({
                      color: 'success',
                      title: 'Başarılı !',
                      text: 'Yorumunuz Eklendi '
                    });
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Hata !',
                    text: 'Yasaklı Kullanıcı Ekleme Başarısız ! '
                  });
                }
              }).catch((error) => {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: error.response.data.Errors[0].Message
                });
              });
      }
    },
    showStatusLogs() {
      getLogs(this.data.id).then((res) => {
        if (res && res.status == 200) {
          this.statusLogs = res.data;
          this.statusLogsPopupActive = true;
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Statü logları yüklenirken bir hata oluştu.'
          });
        }
      }).catch((error) => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Statü logları yüklenirken bir hata oluştu.'
        });
      });
    }
    }
}
</script>

<style>
  /* ... (mevcut stiller korundu) ... */

  .status-log-item {
    border-bottom: 1px solid #e0e0e0;
    padding: 10px 0;
  }

  .status-log-item:last-child {
    border-bottom: none;
  }

  .log-text {
    font-size: 14px;
    color: #333;
  }

  .log-user {
    font-size: 12px;
    color: #666;
  }

  .log-date {
    font-size: 12px;
    color: #999;
  }
</style>
<style scoped>
.content-wrapper {
  max-height: calc(100vh - 250px);
  overflow-y: auto;
}

.content-wrapper {
  word-wrap: break-word;
}
</style>